import $ from 'jquery';
import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import FlipBox from '../../prelogin/src/components/FlipBox';
import SampleLessonLayout from '../../prelogin/src/components/SampleLessonLayout';
import Swiper from 'react-id-swiper';
import { func } from 'prop-types';
import Slider from "react-slick";
import HmAjax from '../../util/HmAjax';

import TestTakingModalComponent from '../../views/plp/TestTakingModalComponent';
import BillingForm from '../../views/purchase/TchrBillingForm';
import NativeAjax from '../../util/NativeAjax';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import CouponCodeModel from '../../views/purchase/CouponCodeModel';
import CouponCodeLayout from '../../views/purchase/CouponCodeLayout';

import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import SelectDropdown from '../login/RemedialSelectDropdown';

const redirection_url_key = "login-redirect-purchase";

export default class CommonProductCatalogue  extends PreLoginPage {

    constructor(props){
        super(props)
        this.state={
            tchrdata:{},
            chooseGrade:null,            
            products_details: {},
            OPSAvailable:false,
            ModalShow:false,
            review_order:false,
            BillingFormShow:false,
            currentGradeIndex:this.getSelectedIndex(0),
            dataLoaded: false,
            teacherLessonsList:null,
            selectedGrade:'',
            purchaseObj:null,
            noData: false,
            couponApplied:false,
            SubscribeModal:false,
            trackId:0,
            couponCodeTracked:false
        };
        this.slider = null;
        this.productCateBox = this.productCateBox.bind(this);
        this.renderClassTab=this.renderClassTab.bind(this);
        this.similarLessonList = {};


        this.productsJson = {};
        //this.purchaseObj = null;
        this.appDetails =  {};
        this.tchrgradeOrder=[];
        
        this.productEvt = null;

        this.teacherLumosProduct = null;

        this.showBillingForm = this.showBillingForm.bind(this);
        this.renderbillingForm = this.renderbillingForm.bind(this);
        this.showOrderReview = this.showOrderReview.bind(this);
        this.hideBillingModal=this.hideBillingModal.bind(this);
        this.hideReviewModal = this.hideReviewModal.bind(this);
        this.teachergradeSwiper = this.teachergradeSwiper.bind(this);
        this.couponValidFn = this.couponValidFn.bind(this);
        this.setTrackId = this.setTrackId.bind(this);
        this.SuccesscallBackFn = this.SuccesscallBackFn.bind(this);
        this.hideSubscribeModal =  this.hideSubscribeModal.bind(this);
        this.isCouponAllowed = this.isCouponAllowed.bind(this);
    }

     getProdFromQryParam(){
        try{
            let prodKeys = window.catalog_qry_param["product"];
            let prodKey = null;
            const qryParams = this.getQueryParams();

            if(prodKeys && prodKeys.length > 0){
                for(let i=0; i< prodKeys.length; i++){
                    if(prodKey === null){
                        prodKey = qryParams[prodKeys[i]];
                    }else{
                        break;
                    }
                }
            }
           return prodKey;
        }catch(e){
            console.error(e);
        }
        return null;      
    }

    /**
    * VERY IMPORTANT: Override to set based on the Category set in PC Database
    * Default to "TCHR_SPL". 
    */
    getCategory(){
       return "TCHR_SPL";
    }

    /**
    * IMPORTANT: Coupon Code Attribute Prefix to store different user attribute 
    * for different product catalogue
    * Must be Overridden by childClasses
    */
    couponAttrPrefix(){
        return "common";
    }

    onBillingFormClose(){
        //dummy function for now - must be overridden
    }

    /**
    * Override this method to get Products specific to the Product Catalogue
    */
    getProductDetails(){
        var me = this;
        var callBackSuccess = function(response){
            me.SuccesscallBackFn(response)
        }

        var callBackFailure = function(response){   
             me.setState({noData:true});    
            console.log("Error in PRODUCT_DETAILS");        
        }
        new NativeAjax(this.getUrlFor("TCHR_PRODUCTS")).enableCORS().post(callBackSuccess,callBackFailure);
    }

    /**
    * IMPORTANT: Override this function to enable disable
    */
    isCouponAllowed(){
        return false;
    }

    couponValidFn(response){
        if(response && typeof response=="object"){
            this.SuccesscallBackFn(response);
            this.setState({couponApplied:true})
        }
    }

    setTrackId(trackId,couponCodeTracked){
     this.setState({trackId:trackId,couponCodeTracked:couponCodeTracked})
    }

    componentWillMount(){		
		var me =this;
		  var callBackSuccess = function(response){
			if(response !== null){
				if (response.status === 'active') {
					me.setState({OPSAvailable:true});
				}
			}
	
			//console.log("OPS_DETECT response : ", response);
		}
	
		var callBackFailure = function(response){			
			console.log("Error in OPS_DETECT");		
		}
	
        new HmAjax(this.getUrlFor("OPS_DETECT")).get(callBackSuccess,callBackFailure);
        
        // try {
		// 	this.userObj = JSON.parse(BrowserStorageUtil.getStoredItem(this.userDataKey));
		// 	//console.log("userobj::",this.userObj);
		// 	for(var key in this.userObj){
		// 		this.userId = this.userObj[key].USER_DETAILS.userId;
		// 		this.userCountryCode = this.userObj[key].USER_DETAILS.countryCode;
		// 	}
			
		// } catch (e) {}
    }
    
    componentDidMount() {
		var me = this;

		try{
            var refUrl = document.referrer;

            let centaRef = me.callByReferer(refUrl)
            let userLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;
            this.userLoggedIn = userLoggedIn;
            let userOrigin  = this.getUser().getUserOrigin();
            let couponcode = this.getAttribute(me.couponAttrPrefix() + "couponcode") || '';

            let AllowUserOrigin = me.callByOrigin(userOrigin)

            if((centaRef && !userLoggedIn) || (AllowUserOrigin && userLoggedIn && (couponcode==="")))
            {
                me.setState({SubscribeModal:true});
            }
            else if(AllowUserOrigin && (couponcode==="")){
                me.setState({SubscribeModal:true});
            }
            
            me.getProductDetails();
        }catch(e){
            console.error("Error occurred while couponcode", e);
        }		
    }

    getRemedialDDData = () => {
        if(this.state.dataLoaded){
            let tchrdata = this.state.tchrdata;
            let optionArr = [];
            tchrdata.map((gradeInfo,index)=>{
                optionArr.push({label: gradeInfo.gradeName, value: index+1});
            })
            return optionArr;
        }
        return null;
    }
    
    SuccesscallBackFn(response){
        var me = this;
        const category = (BrowserStorageUtil.getStoredItem("remedial") && this.getGeo() === "IN") ? "BRIDGE_IN_PLP" : this.getCategory();

        if(response!==null && category){
            me.productsJson = response;
            var sortedProducts = me.sortProducts(response);
            me.teacherLumosProduct = sortedProducts[0]; 
            
            if(response.categories && response.categories[category]){
                let tchrAlldata = Object.values(response.categories[category].grade_wise);
                console.log("tchrAlldata ",tchrAlldata, " : ",this.getGeo());
                let tchrdata = [];

                tchrdata = tchrAlldata;

                console.log("tchrdata ",tchrdata);
                if(tchrdata && tchrdata.length>0){
                    tchrdata.sort((a,b) => {
                       if(a && b && a.gradeOrder && b.gradeOrder){
                            return a.gradeOrder - b.gradeOrder; 
                       }
                       return 0;
                    })

                    me.tchrgradeOrder = [];                        

                    tchrdata.map((gradeList,index) => {
                        me.tchrgradeOrder.push(gradeList.gradeDisplayName);
                    }                        
                    );
                     
                    let teacherLessonsList = null;
                    let gradeName = (tchrdata[me.state.currentGradeIndex].gradeDisplayName).toLowerCase().replace(/\s/g,'') || '';
                    let TeacherLessonMaps = window.TeacherLessonMaps || {};
                    teacherLessonsList = TeacherLessonMaps[gradeName];

                    const updVar = {teacherLessonsList:teacherLessonsList,chooseGrade:tchrdata[me.state.currentGradeIndex].gradeDisplayName,tchrdata:tchrdata,dataLoaded:true,selectedGrade:gradeName};

                    me.setState(updVar); //chooseGrade:tchrdata[0].gradeDisplayName,

                    setTimeout(() => {
                        me.checkAndMoveSlider();
                    }, 250);                    
                                       
                    me.tabCustomCallBack(updVar);
                 }else{
                    me.setState({noData:true});
                 }
            }else{
                me.setState({noData:true});
            }
        }
    }

    sortProducts(data){
		var products = (data && data.productList && data.productList.length > 0) ? data.productList : [];
		var tchrProducts = [];
		var filterProductCategories = window.teacherProdProducts || [];

		var appName = data.appName;
		var appId = data._appId;
        
        this.appDetails.appName = appName;
        this.appDetails.appId = appId;

		if(products.length > 0){
			for(let i=0;i<products.length;i++){
			if(filterProductCategories && filterProductCategories.length > 0 && filterProductCategories.indexOf(products[i].productCategory) > -1){
				products[i]["appName"] = appName;
				products[i]["appId"] = appId;
				tchrProducts.push(products[i]);
			}else if((!filterProductCategories || filterProductCategories.length == 0) && !isNaN(products[i].productCategory)){
				products[i]["appName"] = appName;
				products[i]["appId"] = appId;
				tchrProducts.push(products[i]);
			}
		}
        }
        //console.warn("tchr prod",tchrProducts);
		return tchrProducts;
     }

      showBillingForm(productObj){
        let me = this;
        let userLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;

        //React.unmountComponentAtNode(document.getElementById('tchrbilling'));

        if(productObj && productObj.productId){
            if(this.state.purchaseObj && this.state.purchaseObj.productId){
                //Product already exists
                if(this.state.purchaseObj.productId !== productObj.productId){
                    this.setState({purchaseObj:null,BillingFormShow:false,ModalShow:false});
                }
            }
        }else{
            return;
        }

        let tempFunc = () => {
            if(typeof me.props.postLoginCallBack === "function"){
                me.props.postLoginCallBack();
            }

            userLoggedIn = (me.getUser().getUserId() && me.getUser().getUserId().length > 0) ? true : false;

            if(productObj && productObj.productId){
                me.purchaseObj = productObj;
                me.setState({purchaseObj:productObj,BillingFormShow:true,ModalShow:true});
            } 
        }

        if(!userLoggedIn){
            if(typeof this.props.showSubscriptionForm === "function"){
                var gradeName = (productObj.gradeName).toLowerCase().replace(/\s/g,'') || '';
                var productName = (productObj.productName).toLowerCase().replace(/\s/g,'') || '';
                this.getAdsTracker().callByReferer({"eventType":"trackCustom","eventName":gradeName+"-"+productName+"-subscribebtn"});
                this.props.showSubscriptionForm(tempFunc);
            }

            //This sets the current URL to redirect on login
            sessionStorage.setItem(redirection_url_key, window.location.href);
        }else{
            tempFunc();
        }        
    }

    /**
    * IMPORTANT: Do not override this function
    * This function will move the slider based on the highlighted tab.
    **/
    checkAndMoveSlider(){
        const me = this;
        const recurFn = (allGradeTabs, firstHiddenIdx = 0) => {
            try{                
                if(allGradeTabs[this.state.currentGradeIndex].ariaHidden === "true" || allGradeTabs[this.state.currentGradeIndex].getAttribute("aria-hidden") === "true"){
                    for(let i=0; i< allGradeTabs.length; i++){
                        if(allGradeTabs[i].ariaHidden === "true" || allGradeTabs[i].getAttribute("aria-hidden") === "true"){
                            firstHiddenIdx = i;
                            break;
                        }
                    }                    
                   me.slider.slickGoTo(firstHiddenIdx);
                }                
            }catch(e){
                console.error(e);
            }
        }   

        if(this.slider && typeof this.slider.slickGoTo === "function"){
            try{
             const allGradeTabs = $(".slick-track").children();
             
             if(allGradeTabs && allGradeTabs.length > 0){
                recurFn(allGradeTabs);                
             }
            }catch(e){
                console.error("Error while trying to move the slider ::" , e);
            }
        }        
    }

	hideBillingModal(){ // Shyam
        /*
        * IMPORTANT: It is very IMPORTANT to unmount the Billing form.
        */
		this.setState({ModalShow:false});
	}

	showOrderReview(){
		this.setState({review_order:true});
	}

	hideReviewModal(){
        this.setState({review_order:false});
    }

    hideSubscribeModal(){
        this.setState({SubscribeModal:false});
    }

    renderCouponCodeModel(){
        if(!this.state.couponApplied){
            let couponCode = this.getAttribute(this.couponAttrPrefix() + "couponcode") || '';
            return (
                <CouponCodeModel {...this.props} couponPrefix={this.couponAttrPrefix()} couponCode={couponCode} setTrackId={this.setTrackId} couponApplied={this.state.couponApplied} hideSubscribeModal={this.hideSubscribeModal} showSubscriptionForm={this.props.showSubscriptionForm} callBackParent={this.couponValidFn} SubscribeModal={this.state.SubscribeModal} couponCodeTracked={this.state.couponCodeTracked}/>
            )
        }
    }

    callByReferer(url){
        var couponTrackers = window.couponTrackers || {}
        if(url && couponTrackers){
            for(var i in couponTrackers){
                if(url.match(i)){
                    return true;
                }
            }
        }
        return false;
    }

    callByOrigin(origin){
        var couponPopup = window.couponPopup || []
        if(origin && origin.length > 1 && couponPopup && couponPopup.length > 0){
            return (~couponPopup.indexOf(origin)) ? true : false;
        }
        return false;
    }
    
    renderbillingForm(){
        //console.log("renderbilling Form ",this.state.ModalShow);
        return (
                <div>
                    <TestTakingModalComponent visible={this.state.ModalShow} dialogClassName="modal-md">
                    <div className="loginHeader text-center">	
                    <div className="text-center modallogo loginHeaderTxt">
                    {this.rb("billing.information")}
                    </div>
                    <div className="close loginClose" onClick={this.hideBillingModal}  aria-label="Close">
                    <span aria-hidden="true"><i className="material-icons">close</i></span>
                    </div>
                    </div>
                    <div className="modal-body">
                    {
                        (()=>{
                            if(this.state.purchaseObj && this.state.ModalShow){
                                return (
                                    
                                    <BillingForm trackId={this.state.trackId} purchaseObj={this.state.purchaseObj} productsJson={this.productsJson} myProps={this.props}  ModalShow={this.state.ModalShow} showBillingForm={this.showBillingForm} hideBillingModal={this.hideBillingModal} review_order={this.state.review_order} showOrderReview={this.showOrderReview} hideReviewModal={this.hideReviewModal} purchaseKey={this.state.purchaseKey} />
                                    
                                )
                            }else if(!this.state.ModalShow){
                                this.onBillingFormClose();
                                return null;
                            }
                        })()
                    }
                    </div>							
                    </TestTakingModalComponent>
                </div>
        )
    }

    getSelectedIndex(indVal){
        if(sessionStorage.getItem(this.getCategory()+"-catalogue") && !isNaN(sessionStorage.getItem(this.getCategory()+"-catalogue"))){
            return Number(sessionStorage.getItem(this.getCategory()+"-catalogue"));
        }

        return indVal;
    }

    setSelectedIndex(indVal){
        if(!isNaN(indVal)){
            sessionStorage.setItem(this.getCategory()+"-catalogue", indVal);
        }
    } 

    renderClassTab(list,indVal){
        if(this.state.chooseGrade == list || this.state.currentGradeIndex === indVal){
            return (
                <div className="swiper-slide" key={indVal} >
           <div >
           <div className="swiper-active" data-grade={list} data-index={indVal} onClick={this.gradeTabClickFn.bind(this)}>
        {list}
               </div>
               </div>
            </div>
            )
        }else{
            return (
                <div className="swiper-slide" key={indVal} >
           <div>
           <div className="grade" data-grade={list} data-index={indVal} onClick={this.gradeTabClickFn.bind(this)}>
           {list}
               </div>
               </div>
            </div>
            )
        }
    }

    getLengthtoSlideShow = (val) => {
        let me=this;
        var gradeLen = me.tchrgradeOrder.length;
        let lengGrade = gradeLen > val ? val : gradeLen;
        return lengGrade;
    }

    teachergradeSwiper(){                 
         var me=this;
         if(me.state.tchrdata && me.state.tchrdata!=null && me.tchrgradeOrder.length>0){
            var settings = {
                dots: false,
                infinite: false,
                speed: 300,
                slidesToShow: me.getLengthtoSlideShow(5),
                slidesToScroll: me.getLengthtoSlideShow(5),
                responsive: [
                {
                    breakpoint: 1370,
                    settings: {
                        slidesToShow: me.getLengthtoSlideShow(5),
                        slidesToScroll: me.getLengthtoSlideShow(5),
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 1100,
                    settings: {
                        slidesToShow: me.getLengthtoSlideShow(4),
                        slidesToScroll: me.getLengthtoSlideShow(4),
                        infinite: false,
                        dots: false
                    }
                },
                {
                    breakpoint: 767,
                    settings: {
                        slidesToShow: me.getLengthtoSlideShow(3),
                        slidesToScroll: me.getLengthtoSlideShow(3),
                    }
                },
                {
                    breakpoint: 550,
                    settings: {
                        slidesToShow: me.getLengthtoSlideShow(1),
                        slidesToScroll: me.getLengthtoSlideShow(1),
                    }
                }
                        // You can unslick at a given breakpoint now by adding:
                        // settings: "unslick"
                        // instead of a settings object
                        ]
                    };

                    
            return(
                <div className="row tchrswiper">   
                        <div className="swiper-container row allMiddle">
                            <div className="col-sm-12 col-xs-12 col-md-12 col-lg-12 imgGal">
                                <div className="col-12 text-center scorecardLessons">

                                <Slider ref={slider => (this.slider = slider)} {...settings}>
                                    {
                                         me.tchrgradeOrder.map((list, index) =>                
                                         this.renderClassTab(list,index)
                                         )
                                        
                                        }
                                     </Slider>
                                </div>
                            </div>
                        </div>
                    </div> 	
            )
         }
    }

    gradeTabClickFn(e){
        //console.warn("grade ",e.target.dataset.index);
        let allElements = Array.from(document.querySelectorAll('.swiper-active'));
        for (let element of allElements) {
          if($(element).hasClass('swiper-active')){
            element.classList.remove('swiper-active')
            element.classList.add('grade')
          }
        }
       if($(e.target).hasClass('grade')){
            $(e.target).removeClass('grade')
            $(e.target).addClass("swiper-active");
        }

        let teacherLessonsList = null;
        let gradeName = (this.state.tchrdata[e.target.dataset.index].gradeName).toLowerCase().replace(/\s/g,'') || '';
        let TeacherLessonMaps = window.TeacherLessonMaps || {};
        teacherLessonsList = TeacherLessonMaps[gradeName];

          $(".tchrprodanim").animate({
            opacity: 0
          },"fast",function(){
                $(".tchrprodanim").animate({
                        opacity: 1
                    });   
          });
          
        this.setSelectedIndex(e.target.dataset.index);


        this.tabCustomCallBack({teacherLessonsList:teacherLessonsList,selectedGrade:gradeName,currentGradeIndex:e.target.dataset.index,chooseGrade:e.target.dataset.grade});

        this.setState({teacherLessonsList:teacherLessonsList,selectedGrade:gradeName,currentGradeIndex:e.target.dataset.index,chooseGrade:e.target.dataset.grade});
    }

    setFreeProductsFirst = (gradeData) =>{
        let FreeProdArr = [];
        let PaidProdArr = [];
        const allProdCount = Object.values(gradeData).length;
        Object.values(gradeData).map((grade,index) => {
            if(grade.productPrice > 0){
                PaidProdArr.push(grade);
            }else{
                FreeProdArr.push(grade);
            }
        })
        let FinalProd = [];
        /**
        * IMPORTANT: Sort free-paid combo per row
        **/
        for(let i=0; i<allProdCount; i++){
            if(FreeProdArr[i]){
                FinalProd.push(FreeProdArr[i]);
            }            
            if(PaidProdArr[i]){
                FinalProd.push(PaidProdArr[i]);
            }
        }
        //FinalProd = FreeProdArr.concat(PaidProdArr);
        return FinalProd;
    }

    //This function needs to be overridden
    tabCustomCallBack(tab){

    }

    productCateBox(){
        var me = this;
        let gradeData = null;

        if(me.state.tchrdata && me.state.tchrdata!=null && me.tchrgradeOrder.length>0 /*&& me.state.teacherLessonsList*/){
            gradeData = me.state.tchrdata[me.state.currentGradeIndex].tariffDetails;
            let gradeDataFinal = [];
            gradeDataFinal = me.setFreeProductsFirst(gradeData);
            //console.log("lalala gradeData::", me.state.tchrdata[me.state.currentGradeIndex]);

            return(
                <div className="flex-container">
                {
                    (()=>{
                        return (gradeDataFinal.map((gradeBox,index) => 
                        {
                            let tariffId = gradeBox.tariffId;
                            let productDetails = gradeBox.productDetails;
                            let category = me.getCategory();

                        return (
                            <FlipBox custom={this.onClickCustomCallBack} category={category} key={tariffId} OPSAvailable={me.state.OPSAvailable} teacherLessonsList={() => (me.state.teacherLessonsList) ? me.state.teacherLessonsList[index] : null} gradeBox={gradeBox} productDetails={productDetails} gradeName={me.state.selectedGrade} showBillingForm={me.showBillingForm} appDetails={this.appDetails} showSubscriptionForm={this.props.showSubscriptionForm}></FlipBox>
                        )
                        }
                    ))
                    })()
                }
                </div>
            )
        }
    }

    getSampleLessons(){
        var me=this;
        if(me.state.tchrdata[me.state.currentGradeIndex].sampleLessons){
            let sampleLessons= me.state.tchrdata[me.state.currentGradeIndex].sampleLessons;
            if(sampleLessons && sampleLessons.length > 0){
                return(
                     <SampleLessonLayout sampleLessons={sampleLessons}></SampleLessonLayout>
                )
            }else{
                return null;
            }            
        }
    }

    getBuyOptions(){
        if(this.state.BillingFormShow && this.state.purchaseObj){
            return this.renderbillingForm()
        }
    }
    
    getProductBoxes(){
        if(this.state.currentGradeIndex >= 0 && this.state.tchrdata){
            return(
                <div className="tchrprodanim">
                 {this.getSampleLessons()}
                 {this.productCateBox()}
                 {this.getBuyOptions()}
                </div>
            )
        }
    }

    couponLayout () {

        let userLoggedIn = (this.getUser().getUserId() && this.getUser().getUserId().length > 0) ? true : false;
        let userOrigin  = this.getUser().getUserOrigin();
       
        let boxlocked = '';
        if(this.state.couponApplied){
            boxlocked = "disabled"
        }
        let couponCode = this.getAttribute(this.couponAttrPrefix() + "couponcode") || '';
            return(
                <div className={"CouponCodeBoxLayout "+boxlocked}>
                  <CouponCodeLayout {...this.props} couponPrefix={this.couponAttrPrefix()} couponCode={couponCode} couponApplied={this.state.couponApplied} showSubscriptionForm={this.props.showSubscriptionForm} setTrackId={this.setTrackId} callBackParent={this.couponValidFn} couponCodeTracked={this.state.couponCodeTracked}/>  
                </div>
                
            )
    }

    setClassForPage = (e) => {
        console.log("setClassForPage ",e, " : ",this.state.tchrdata);
        let gradeName = "";
        let indexVal = 0;
        this.state.tchrdata.map((data,index)=>{
            if(data.gradeName === e.label){
                indexVal = index;
                gradeName = (data.gradeName).toLowerCase().replace(/\s/g,'') || '';
            }
        })
        if(gradeName && gradeName.length>0){
            this.setState({selectedGrade:gradeName,currentGradeIndex:indexVal,chooseGrade:gradeName});
           // console.log("setClassForPage ",gradeName);
        } 
    }

    handleSubmit = (e) => {
        //console.log("handleSubmit ");
    }

    teacherDDSwiper = () => {
       if(this.state.tchrdata){
        return(
            <div>
                <FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
		onSubmit={this.handleSubmit} noValidate>
                <FormGroup for="class_dropdown" className="classSelection remedialdd">  
							<SelectDropdown getRemedialDDData={this.getRemedialDDData} selectedValue={1} callBack={this.setClassForPage}></SelectDropdown>
							<FieldFeedbacks for="class_dropdown">
							<FieldFeedback when="valueMissing">{this.rb("billing.classrequired")}</FieldFeedback>	
							<FieldFeedback when="*" />
							</FieldFeedbacks> 
				</FormGroup>
                </FormWithConstraints>
            </div>
        )
       }
    }
  
    render(){
        var me=this;
        if(this.state.dataLoaded){
            return(
                <div className="tchrprodcomp container">
 
                 {
                     (() => {
                        
                         if(me.state.chooseGrade){
                             return(
                               <div>
                                     <div className="container">  
                                {
                                    (()=>{
                                        if(this.isCouponAllowed() && !this.state.SubscribeModal){
                                            return me.couponLayout()
                                        }
                                    })()
                                }

                                {/* {me.couponLayout()} */}

                                {
                                    (()=>{
                                        if(window.remedialAllowFilter && BrowserStorageUtil.getStoredItem("remedial") && this.getGeo() === "IN"){
                                            return me.teacherDDSwiper()
                                        }else{
                                            return me.teachergradeSwiper()
                                        }
                                    })()
                                }
                         
                     
                     
                 </div> 
                             <hr/>
                                {me.getProductBoxes()}
                                {
                                    (()=>{
                                        if(this.isCouponAllowed() && this.state.SubscribeModal){
                                            return me.renderCouponCodeModel()
                                        }

                                    })()
                                }
                                   </div>
                             )
                         }
 
                         
                 })()
 
                 }

                
 
                </div>
              
         )
        }else if(this.state.noData){
            return (<div></div>);
        }else{
            return super.render();
        }
       
    }

}


// WEBPACK FOOTER //
// ./src/views/others/CommonProductCatalogue.js